import React from 'react';
import PropTypes from 'prop-types';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import { useTheme } from '@mui/material';
import FingoStepLabel from '../step-labels/FingoStepLabel';
import VerticalStepConnector from '../step-connectors/VerticalStepConnector';

const VerticalStepper = ({
  steps,
  activeStep,
  handleClick,
  staticMode,
  iconSize,
}) => {
  const theme = useTheme();
  const connectorColor = staticMode ? theme.palette.primary.A700 : theme.palette.neutral.A500;
  return (
    <Stepper
      activeStep={activeStep}
      orientation="vertical"
      connector={(
        <VerticalStepConnector
          connectorColor={connectorColor}
          iconSize={iconSize}
        />
      )}
      sx={{
        padding: {
          xs: '1.5rem 1rem 2rem 1rem',
          md: '1.5rem 2rem 3rem 3rem',
        },
      }}
    >
      {steps.map(({ id, stepTitle }, index) => (
        <Step
          key={id}
          onClick={() => handleClick(index)}
          sx={{
            backgroundColor: 'transparent',
          }}
        >
          <FingoStepLabel
            title={stepTitle}
            staticMode={staticMode}
            iconSize={iconSize}
          />
        </Step>
      ))}
    </Stepper>
  );
};

VerticalStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    stepTitle: PropTypes.string.isRequired,
  })).isRequired,
  activeStep: PropTypes.number,
  handleClick: PropTypes.func.isRequired,
  staticMode: PropTypes.bool,
  iconSize: PropTypes.string,
};

VerticalStepper.defaultProps = {
  activeStep: 0,
  staticMode: true,
  iconSize: '45px',
};

export default VerticalStepper;
